import { graphql, Link } from "gatsby"
import React from "react"
import Footer from "../../components/shared/footer"
import Layout from "../../components/shared/layout"
import SEO from "../../components/shared/seo"
import FixedHeaderSpacer from "../atoms/fixed-header-spacer"
import { IContentfulTag } from "../types/blog.types"
import InternalRoutes from "../util/internal-routes"
import ListingArticles from "./article-listing/articles"
import ListingBreadcrumbs from "./article-listing/breadcrumbs"
import ListingHeader from "./article-listing/header"
import ListingPagination from "./article-listing/pagination"

const TopicPage = ({ pageContext, data: { articles }, location }) => {
  const { currentPage, numPages } = pageContext
  const topic: IContentfulTag = {
    name: pageContext.topicName,
    slug: pageContext.topicSlug,
  }
  const category: IContentfulTag = {
    name: pageContext.categoryName,
    slug: pageContext.categorySlug,
  }
  return (
    <Layout showBackground={true} contactLightbox={true} location={location}>
      <SEO title={topic.name} />
      <FixedHeaderSpacer />
      <ListingBreadcrumbs>
        <Link to={InternalRoutes.Blog()}>Home</Link>
        <Link to={InternalRoutes.Blog(category)}>{category.name}</Link>
        <Link to={InternalRoutes.Blog(category, topic)}>{topic.name}</Link>
      </ListingBreadcrumbs>
      <ListingHeader
        title={topic.name}
        subtitle={`${articles.totalCount} Article${
          articles.totalCount > 1 ? `s` : ``
        }`}
      />
      <ListingArticles articles={articles.edges} />
      <ListingPagination
        currentPage={currentPage}
        totalPages={numPages}
        pagePrefix={InternalRoutes.Blog(category, topic)}
      />
      <Footer />
    </Layout>
  )
}

export default TopicPage

export const topicPageQuery = graphql`
  query ($categorySlug: String, $topicSlug: String, $limit: Int, $skip: Int) {
    articles: allContentfulBlogPost(
      filter: {
        tags: {
          category: { slug: { eq: $categorySlug } }
          topic: { slug: { eq: $topicSlug } }
        }
      }
      sort: { order: DESC, fields: publishDate }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          ...ContentfulBlogPostFragment
        }
      }
      totalCount
    }
  }
`
